import { useTranslation } from 'react-i18next';

export default function MaterialsFinishes() {
  const { t } = useTranslation();

  const materials = [
    { number: '1', name: t('material_1_name'), description: t('material_1_desc') },
    { number: '2', name: t('material_2_name'), description: t('material_2_desc') },
    { number: '3', name: t('material_3_name'), description: t('material_3_desc') },
    { number: '4', name: t('material_4_name'), description: t('material_4_desc') },
    { number: '5', name: t('material_5_name'), description: t('material_5_desc') },
    { number: '6', name: t('material_6_name'), description: t('material_6_desc') },
    { number: '7', name: t('material_7_name'), description: t('material_7_desc') },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Mobile Title */}
        <h2 className="lg:hidden text-4xl font-bold mb-12 text-gray-900 text-center">
          {t('materials_title')}
        </h2>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative h-[600px] rounded-2xl overflow-hidden">
            <img
              src="https://static.readdy.ai/image/33b16dd6ef2caf2f6d4842e4f7285eda/3fa972c7307bd837e1084bf8bdd82161.jpeg"
              alt={t('materials_title')}
              className="w-full h-full object-contain md:object-cover md:object-center"
            />
          </div>

          {/* Right: Materials List */}
          <div className="flex flex-col justify-center">
            {/* Title - hidden on mobile, visible on desktop */}
            <h2 className="hidden lg:block text-4xl md:text-5xl font-bold mb-12 text-gray-900">
              {t('materials_title')}
            </h2>

            <div className="space-y-6">
              {materials.map((material) => (
                <div key={material.number} className="flex items-start gap-6">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-gray-900 flex items-center justify-center">
                    <span className="text-white font-bold text-lg">{material.number}</span>
                  </div>
                  <div className="flex-1 pt-1">
                    <h3 className="text-xl font-bold text-gray-900 mb-1">
                      {material.name}
                    </h3>
                    <p className="text-gray-600 text-base">
                      {material.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
